const wallet = {
    getlist: 'wallet/getlist-by-admin',
    transactions: 'wallet/transactions-by-admin',
}
export default wallet
